const awsConfig = {
    Auth: {
        region: 'us-east-1',
        userPoolId: 'us-east-1_Sk3ZIowIH',
        userPoolWebClientId: '586mb41rggl589qrjs8gfrif03',
        oauth: {
            domain: 'td-uat-dg-auth.indecomm.net',
            scope: [
                'openid',
                'email',
                'profile',
                'aws.cognito.signin.user.admin'
            ],
            redirectSignIn: 'https://td-uat-dg.indecomm.net/saml-callback',
            redirectSignOut: 'https://td-uat-dg.indecomm.net/logout',
            // redirectSignIn: 'http://localhost:3000/saml-callback',
            // redirectSignOut: 'http://localhost:3000/logout',
            responseType: 'code',
            identityProvider: 'TDUATPingFederate'

        },
        federationTarget: 'COGNITO_USER_POOLS'
    }
};

// export default awsConfig;
// const awsConfig = {
//     Auth: {
//         region: 'us-west-2',
//         userPoolId: 'us-west-2_0tc85Okv4',
//         userPoolWebClientId: '1d2gomcrd0vm59vsndua26eabt',
//         oauth: {
//             domain: 'dgv2-pf-sso.auth.us-west-2.amazoncognito.com',
//             scope: [
//                 'openid',
//                 'email',
//                 'profile',
//                 'aws.cognito.signin.user.admin'
//             ],
//             redirectSignIn: 'https://main.d24jxg75v6ix2h.amplifyapp.com/saml-callback',
//             redirectSignOut: 'https://main.d24jxg75v6ix2h.amplifyapp.com/logout',
//             responseType: 'code',
//             identityProvider: 'PingFederate'
//         },
//         federationTarget: 'COGNITO_USER_POOLS'
//     }
// };

export default awsConfig;